import React, { useMemo, useState } from "react";
import { RiDeleteBin6Line } from "react-icons/ri";
import DataTable from "react-data-table-component";
import { LuArrowUpDown } from "react-icons/lu";
import "../assets/css/styles.css";
import Popover from "./popover";
import { useEffect } from "react";
import EditStandardNotePopup from "../Popup/editStandardNotePopup";

const SortIcon = ({ sortDirection }) => {
  if (sortDirection === "asc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  if (sortDirection === "desc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  return (
    <LuArrowUpDown
      className="ml-1 !w-4 !h-5"
      style={{ color: "#EFEFEF", opacity: "1" }}
    />
  );
};

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#376EA4",
      color: "#FAFDFF",
      fontSize: "16px",
      fontFamily: "InterBold",
      padding: "15px",
      opacity: "1",
      textAlign: "center",
    },
    hoverStyle: {
      color: "#FAFDFF",
      opacity: "1",
    },
  },
  rows: {
    style: {
      fontSize: "16px",
      color: "#828282",
      padding: "6px",
      backgroundColor: "rgba(252, 252, 252, 0.5) !important",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8) !important",
      borderTop: "1px solid rgba(239, 239, 239, 0.8) !important",
      "&:nth-child(2n)": {
        backgroundColor: "rgba(249, 249, 249, 0.6) !important",
      },
      textAlign: "center",
    },
    highlightOnHoverStyle: {
      fontSize: "16px",
      color: "#202020",
      padding: "6px",
      backgroundColor: "#F4F9FF !important",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8) !important",
      borderTop: "1px solid rgba(239, 239, 239, 0.8) !important",
    },
  },
  table: {
    style: {
      display: "block",
      maxHeight: "calc(100vh - 330px)",
      height: "fit-content",
      overflowY: "auto",
      borderCollapse: "separate",
      borderSpacing: 0,
      "@media screen and (min-width: 1600px)": {
        maxHeight: "calc(100vh - 340px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 760px) and (max-width: 1250px)": {
        maxHeight: "calc(100vh - 330px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 768px) and (max-width: 1024px)": {
        maxHeight: "calc(100vh - 360px)",
        overflowX: "hidden",
      },
    },
  },
};

const StandardNotesTable = ({
  searchItem,
  standardNoteList,
  getStandardNoteList,
}) => {
  const [openEditDetailPopup, setOpenEditDetailPopup] = useState(false);
  const HandleRemovePopUp = () => setOpenEditDetailPopup(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const HandleDeleteRemovePopUp = () => setDeletePopup(false);
  const [selectedStandardNote, setSelectedStandardNote] = useState([]);

  const memoizedStandardNotesList = useMemo(
    () => standardNoteList,
    [standardNoteList]
  );

  const filteredData = React.useMemo(() => {
    const standardNotesData = [...(memoizedStandardNotesList || [])];

    return standardNotesData.filter((x) => {
      const dentistDisplayName = x.dentistDisplayName
        ? x.dentistDisplayName.toString().toLocaleLowerCase()
        : "";
      const workTypeName = x.workTypeName
        ? x.workTypeName.toString().toLocaleLowerCase()
        : "";
      const standardNotes = x.standard_Notes
        ? x.standard_Notes.toString().toLocaleLowerCase()
        : "";

      return (
        dentistDisplayName.includes(searchItem.toLocaleLowerCase()) ||
        workTypeName.includes(searchItem.toLocaleLowerCase()) ||
        standardNotes.includes(searchItem.toLocaleLowerCase())
      );
    });
  }, [memoizedStandardNotesList, searchItem]);

  const columns = [
    {
      name: "Dentist Name",
      selector: (row) => row?.dentistDisplayName,
      width: "30%",
      sortable: true,
      sortFunction: (a, b) =>
        a.dentistDisplayName.localeCompare(b.dentistDisplayName),
    },
    {
      name: "Work Type Name",
      selector: (row) => row?.workTypeName,
      width: "30%",
      sortable: true,
    },
    {
      name: "Bitte Beachten",
      selector: (row) => row?.standard_Notes,
      width: "25%",
      sortable: true,
    },
    {
      name: "Vorschau",
      className: "w-32 px-3",
      selector: (row) => row.actions,
      width: "15%",
      sortable: false,
      cell: (row) => (
        <div className="flex items-center gap-4">
          <Popover
            trigger="hover"
            content={
              <p
                className=" absolute -right-0 -top-7 max-w-fit px-2 py-1 text-lg bg-blue rounded text-blue-400 w-auto whitespace-nowrap after:content-[' '] after:-bottom-2 after:left-0 after:right-0 after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-blue shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] font-interRegular"
                style={{}}
              >
                Bearbeiten
              </p>
            }
          >
            <button
              onClick={() => {
                setOpenEditDetailPopup(true);
                setSelectedStandardNote(row);
              }}
              className="rounded-lg p-2 my-1 border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)] transition-all ease-in focus:border-blue-600"
              style={{
                backgroundColor: "rgba(201, 226, 252, 0.3)",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              <img src="./icons/edit_square.svg" width="20px" height="20px" />
            </button>
          </Popover>
          <Popover
            trigger="hover"
            content={
              <p
                className="text-blue-400 px-2 py-1 text-lg bg-red rounded w-full whitespace-nowrap after:content-[' '] after:bottom-0 after:left-0 after:right-0 after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-red shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] font-interRegular"
                style={{}}
              >
                Delete
              </p>
            }
          ></Popover>
        </div>
      ),
      ignoreRowClick: true,
      // allowoverflow: true,
      // button: true,
    },
  ];

  return (
    <div>
      <DataTable
        noDataComponent={
          <div className="py-4 text-gray-500">
            Es sind keine Datensätze zum Anzeigen vorhanden
          </div>
        }
        className="mt-6 !rounded-xl shadow-[0_0_8px_rgba(44,99,152,0.2)] font-interRegular"
        scrollable
        scrollHeight="590px"
        columns={columns}
        data={filteredData || []}
        pagination={false}
        fixedHeader
        customStyles={customStyles}
        sortIcon={<SortIcon />}
        highlightOnHover
      />

      <EditStandardNotePopup
        getStandardNoteList={getStandardNoteList}
        selectedStandardNote={selectedStandardNote}
        setSelectedStandardNote={setSelectedStandardNote}
        openPopUp={openEditDetailPopup}
        closePopUp={HandleRemovePopUp}
        standardNoteList={memoizedStandardNotesList}
      />
    </div>
  );
};

export default StandardNotesTable;
